import { yup } from '@framework/validation/initYup.ts';
import { createUniqueAliasesTest } from './schemaValidationUtils.ts';

/**
 * Schema Yup per la configurazione dell'interrogazione
 * (Identify) di un singolo layer.
 *
 * Segue il pattern competence/labeling: quando `enabled`
 * e' false i campi dipendenti restano presenti ma non
 * obbligatori, cosi' la configurazione (attributi, alias,
 * titolo) viene preservata anche a feature disattivata.
 *
 * Quando `enabled` e' true:
 * - `attributes` richiede almeno un elemento
 * - `aliases` deve contenere valori univoci
 * - `maxResults` e' obbligatorio (default 100)
 *
 * `title` e' sempre facoltativo: se vuoto, nel pannello risultati si usa
 * l'etichetta (nome) del livello.
 */
export const MapLayerIdentifySchema = yup
  .object({
    /**
     * Abilita l'interrogazione per questo layer.
     * Default: false.
     */
    enabled: yup.boolean().default(false).label('Interrogazione abilitata'),
    /**
     * Titolo mostrato nel pannello risultati. Facoltativo (vuoto di default):
     * se vuoto, nel pannello si usa l'etichetta (nome) del livello.
     */
    title: yup.string().default('').label('Titolo Interrogazione'),
    /**
     * Nomi delle proprieta' da estrarre dalle feature
     * interrogate. Almeno uno se enabled.
     */
    attributes: yup
      .array(yup.string().required())
      .default([])
      .label('Attributi')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.min(1).required() : schema.notRequired(),
      ),
    /**
     * Mappatura da nome attributo sorgente a label
     * leggibile. I valori devono essere univoci.
     */
    aliases: yup
      .object()
      .default({})
      .label('Alias attributi')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.test(createUniqueAliasesTest()) : schema.notRequired(),
      ),
    /**
     * Se true, l'interrogazione e' visibile solo
     * in Back Office.
     */
    backOfficeOnly: yup
      .boolean()
      .default(false)
      .label('Visibile solo in Back Office'),
    /**
     * Numero massimo di feature restituite
     * dall'interrogazione.
     */
    maxResults: yup
      .number()
      .integer()
      .min(1)
      .default(100)
      .label('Numero massimo risultati')
      .when(['enabled'], ([enabled], schema) =>
        enabled ? schema.required() : schema.notRequired(),
      ),
  })
  .default({})
  .addChildrenParentDeps();
